import {isPlainObject, isArray, each} from "lodash"

/** @deprecated this is naughty, and requires mutating values potentially in cache */
export function stripEtag(data: any) {
  // data can come from frozen storage, e.g apollo cache, so we clone the data before sending it
  const mutable = structuredClone(data)
  _stripEtag(mutable)
  return mutable
}

function _stripEtag(data: any) {
  if (isArray(data)) {
    each(data, (item) => _stripEtag(item))
  } else if (isPlainObject(data)) {
    data.etag = undefined // inconsitency in BE services
    data.Etag = undefined
    each(data, (item) => {
      if (shouldIterate(item)) _stripEtag(item)
    })
  }
}

function shouldIterate(obj: any) {
  return isPlainObject(obj) || Array.isArray(obj)
}
